import importerStore from '@shared/importer/importer-store';
import { SubprogramService } from '@modules/subprogram/subprogram-service';
import subprogramImporterFields from '@modules/subprogram/subprogram-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  SubprogramService.import,
  subprogramImporterFields,
  i18n('entities.subprogram.importer.fileName'),
  i18n('entities.subprogram.importer.hint'),
);
